/*
 *
 * Dashboard constants
 *
 */

export const GET_AMBASSADOR_PROFILE_WATCHER =
  "app/Dashboard/Ambassador/GET_AMBASSADOR_PROFILE_WATCHER"
export const GET_AMBASSADOR_PROFILE_SUCCESS =
  "app/Dashboard/Ambassador/GET_AMBASSADOR_PROFILE_SUCCESS"

export const GET_DASHBOARD_WATCHER =
  "app/Dashboard/Ambassador/GET_DASHBOARD_WATCHER"
export const GET_DASHBOARD_SUCCESS =
  "app/Dashboard/Ambassador/GET_DASHBOARD_SUCCESS"

export const GET_TASK_WATCHER = "app/Dashboard/Ambassador/GET_TASK_WATCHER"
export const GET_TASK_SUCCESS = "app/Dashboard/Ambassador/GET_TASK_SUCCESS"

export const SUBMIT_FEEDBACK_SURVEY_WATCHER = "app/Dashboard/Ambassador/SUBMIT_FEEDBACK_SURVEY_WATCHER"
export const DISMISS_FEEDBACK_SURVEY_WATCHER = "app/Dashboard/Ambassador/DISMISS_FEEDBACK_SURVEY_WATCHER"
